import { authHeader } from "./client";
import { getGuestToken } from "../utils/guestToken";

/**
 * 장바구니/주문/결제 API 공용 헤더. accessToken 이 있으면 Authorization 을,
 * 없으면(비회원) X-Guest-Token 을 실어보낸다 - 둘 다 보내도 서버가 Authorization을
 * 우선 사용하므로 안전하다.
 */
export function buildAuthAndGuestHeaders(accessToken) {
  return {
    ...authHeader(accessToken),
    "X-Guest-Token": getGuestToken(),
  };
}
